// import http from '../api/http'

const authRoutes = [
  {
    path: "/execution/:id",
    name: "NewExecution",
    component: () => import("./pages/NewExecution.vue"),
  },
  {
    path: "/continue/:id",
    name: "ContinueExecution",
    component: () => import("./pages/ContinueExecution.vue"),
  },
  {
    path: "/review/:id",
    name: "ReviewExecution",
    component: () => import("./pages/ContinueExecution.vue")
  }
];

export default authRoutes;
